// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2191":"css/admin-app.6942","6614":"css/app.6942"}[chunkId] + ".css";
};